var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgCpuIcon = function SvgCpuIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.667 18.667H5.333V5.333h13.334zm5.333-8V8h-2.667V5.333c0-1.48-1.2-2.666-2.666-2.666H16V0h-2.667v2.667h-2.666V0H8v2.667H5.333a2.657 2.657 0 0 0-2.666 2.666V8H0v2.667h2.667v2.666H0V16h2.667v2.667a2.667 2.667 0 0 0 2.666 2.666H8V24h2.667v-2.667h2.666V24H16v-2.667h2.667a2.667 2.667 0 0 0 2.666-2.666V16H24v-2.667h-2.667v-2.666zm-10.667 2.666h-2.666v-2.666h2.666zM16 8H8v8h8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCpuIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;